@if (actionParams) {
  <div class="form-container">
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Parameters
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="actionParams">
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Name </label>
            </div>
            <input class="control-input" activeForm [activeForm]="actionParams" id="name" [formControlName]="'name'" placeholder="Name the menu header"/>
            <input-validators controlName="name" [control]="actionParams.controls['name']"></input-validators>
          </div>
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> Description </label>
            </div>
            <input class="control-input" activeForm [activeForm]="actionParams" id="description" [formControlName]="'description'" placeholder="Add description"/>
            <input-validators controlName="description" [control]="actionParams.controls['description']"></input-validators>
          </div>
          @if (instances && instances.length > 1) {
            <div class="control-div">
              <div class="control-label-container">
                <label class="control-label"> Instance </label>
              </div>
              <mat-select class="dynamic-dropdown" [formControlName]="'instanceId'" placeholder="Select instance">
                @for (option of instances; track option) {
                  <mat-option [value]="option.id">
                    {{ option.displayName }}
                  </mat-option>
                }
              </mat-select>
              <input-validators controlName="instanceId" [control]="actionParams.controls['instanceId']"></input-validators>
            </div>
          }
          <div class="control-div">
            <div class="control-label-container">
              <label class="control-label"> API </label>
            </div>
            @if (apiProviders) {
              <mat-select class="dynamic-dropdown"
                placeholder="Select API"
                [formControlName]="'apiId'"
                (selectionChange)="getNodeParametersAndGroups($event.value)"
                          hideSingleSelectionIndicator>
                @if (gettingApiProvidersInProgress) {
                  <mat-option class="loading-option">
                    <loading-icon></loading-icon>
                    <div>Loading results...</div>
                  </mat-option>
                }
                @for (option of apiProviders; track option) {
                  <mat-option [value]="option.id">
                    {{ option.name }}
                  </mat-option>
                }
              </mat-select>
            } @else {
              <div class="control-div">
                <div class="api-error-container">
                  <div class="api-error-block">
                    <div class="api-error-title">{{errorTitle ? errorTitle : 'Unable to fetch APIs'}}</div>
                    <div class="api-error-desc">{{errorMsg ? errorMsg : 'Close the node and try again.'}}</div>
                  </div>
                </div>
              </div>
            }
            <input-validators controlName="name" [control]="actionParams.controls['apiId']"></input-validators>
          </div>
        </ng-container>
        @if (gettingNodeParametersInProgress) {
          <div class="loading-container">
            <loading-icon></loading-icon>
          </div>
        } @else {
          <ng-container *ngTemplateOutlet="parameters; context: { parameters: chatHubParameters, parametersData: chatHubParametersData }">
          </ng-container>
          <div class="groups-list">
            <ng-container *ngTemplateOutlet="group; context: {}">
            </ng-container>
          </div>
        }
        @if (gettingNodeParametersError) {
          <ng-container *ngTemplateOutlet="apisError; context: {errorTitle: 'Unable to fetch API details', errorMsg: 'Reselect the API to try again.'}"></ng-container>
        }
      </ng-container>
    </clickatell-expansion-panel>
    <clickatell-expansion-panel>
      <ng-container header>
        <mat-panel-title>
          Logic
        </mat-panel-title>
      </ng-container>
      <ng-container body>
        <ng-container [formGroup]="actionParams">
          <div class="control-div logic-div">
            <div class="logic-item-title logic-item-success">Success</div>
            <ng-container *ngTemplateOutlet="next; context: { controlName: 'success', form: actionParams}">
            </ng-container>
          </div>
          <div class="control-div logic-div">
            <div class="logic-item-title logic-item-error">Error</div>
            <ng-container *ngTemplateOutlet="next; context: { controlName: 'error', form: actionParams}">
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </clickatell-expansion-panel>
  </div>
}

<ng-template #next let-controlName="controlName" let-form="form">
  <label class="point-to-label">
    Point To
    <app-cms class="popover" [type]="'nodeBuild'" [field]="'next'"></app-cms>
  </label>
  @if (nodeFlowDetails) {
    <next-selector [canEditFlows]="canEdit.canEditFlows" [selectorType]="'both'"
      [flowSteps]="nodeFlowDetails.currentFlowSteps" [flows]="nodeFlowDetails.flows"
      [name]="controlName"
      [form]="form"
      [stepId]="nodeFlowDetails.stepId">
    ></next-selector>
  }
</ng-template>


<ng-template #parameters let-parameters="parameters" let-parametersData="parametersData">
  @if (parameters && parametersData) {
    @for (param of parameters.controls; track param; let index = $index) {
      <div [formGroup]="param" >
        @switch (parametersData[index]?.presentationType) {
          @case ('TEXT') {
            <div class="control-div">
              <div class="control-label-container">
                <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                @if (!parametersData[index].required) {
                  <label class="control-optional">Optional</label>
                }
              </div>
              <input class="control-input"
                activeForm
                [activeForm]="param"
                [id]="'parameter-' + index"
                [formControlName]="'value'"
                [placeholder]="parametersData[index].placeholder"/>
                <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
              </div>
            }
            @case ('TEXT_AREA') {
              <div class="control-div">
                <div class="control-label-container">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                  @if (!parametersData[index].required) {
                    <label class="control-optional">Optional</label>
                  }
                </div>
                <textarea class="control-input control-area"
                  activeForm
                  [activeForm]="param"
                  [id]="'parameter-' + index"
                  [formControlName]="'value'"
                  [placeholder]="parametersData[index].placeholder">
                </textarea>
                <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
              </div>
            }
            @case ('NUMBER') {
              <div class="control-div">
                <div class="control-label-container">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                  @if (!parametersData[index].required) {
                    <label class="control-optional">Optional</label>
                  }
                </div>
                <div class="node-field-container">
                  <app-number-selector-input
                    [controlLabel]="parametersData[index].label"
                    [formControlName]="'value'">
                  </app-number-selector-input>
                </div>
                <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
              </div>
            }
            @case ('BOOLEAN') {
              <div class="control-div toggle-field">
                <div class="label-left-block">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                </div>
                <div class="toggle-btn">
                  <mat-slide-toggle [color]="'primary'" class="control-toggle" [formControlName]="'value'">
                  </mat-slide-toggle>
                </div>
              </div>
            }
            @case ('SELECT') {
              <div class="control-div">
                <div class="control-label-container">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                  @if (!parametersData[index].required) {
                    <label class="control-optional">Optional</label>
                  }
                </div>
                <mat-select class="dynamic-dropdown" [formControlName]="'value'">
                  @for (option of parametersData[index].availableOptions; track option) {
                    <mat-option [value]="option.value">
                      {{ option.label }}
                    </mat-option>
                  }
                </mat-select>
                <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
              </div>
            }
            @case ('MULTI_SELECT') {
              <div class="control-div">
                <div class="control-label-container">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                  @if (!parametersData[index].required) {
                    <label class="control-optional">Optional</label>
                  }
                </div>
                <div class="node-field-container">
                  <app-multi-select-dropdown
                    [formControlName]="'value'"
                    [label]="parametersData[index].label"
                    [placeholder]="parametersData[index].placeholder"
                    [tagOptions]="parametersData[index].availableOptions">
                  </app-multi-select-dropdown>
                </div>
                <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
              </div>
            }
            @default {
              <div class="control-div">
                <div class="control-label-container">
                  <ng-container *ngTemplateOutlet="labelTemplate; context: { labelText: parametersData[index].label}"></ng-container>
                  @if (!parametersData[index].required) {
                    <label class="control-optional">Optional</label>
                  }
                </div>
                <input class="control-input"
                  activeForm
                  [activeForm]="param"
                  [id]="'parameter-'+index"
                  [formControlName]="'value'"
                  [placeholder]="parametersData[index].placeholder"/>
                  <input-validators controlName="name" [control]="param.controls['value']"></input-validators>
                </div>
              }
            }
          </div>
        }
      }
    </ng-template>

    <ng-template #group>
      @if (chatHubGroups && chatHubGroupsData) {
        <mat-accordion [multi]="true" #GroupsAccordion="matAccordion">
          @for (groupOption of chatHubGroups.controls; track groupOption; let index = $index) {
            <div class="group-container" [formGroup]="groupOption">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header class="group-header">
                  <div class="group-header-title">
                    <div class="title-text">
                      {{groupOption.value.name}}
                    </div>
                  </div>
                </mat-expansion-panel-header>
                <div class="group-items-container">
                  <mat-accordion [multi]="true" #GroupOptionsAccordion="matAccordion">
                    @for (groupItem of groupOption.controls.items.controls; track groupItem; let groupItemIndex = $index) {
                      <div class="group-item">
                        <div [formGroup]="groupItem">
                          <mat-expansion-panel [expanded]="true">
                            <mat-expansion-panel-header [@.disabled]="true" class="group-item-header">
                              <div class="group-item-header-title">
                                <div class="title-text">{{ groupOption.value.name + ' ' + (groupItemIndex + 1) }}</div>
                                <button class="remove-item-btn" (click)="removeGroupItem($event, groupOption, groupItemIndex)"></button>
                              </div>
                            </mat-expansion-panel-header>
                            <div class="group-item-container">
                              <ng-container *ngTemplateOutlet="parameters; context: { parameters: groupItem.controls.parameters, parametersData: chatHubGroupsData[index].items[groupItemIndex].parameters }">
                              </ng-container>
                            </div>
                          </mat-expansion-panel>
                        </div>
                      </div>
                    }
                  </mat-accordion>
                  <div class="control-div add-group-item-block">
                    <div class="addBtnContainer add-group-item" (click)="addGroupItem(groupOption)">
                      <img src="../../../../../../../../assets/svg/add.svg">
                      Add New {{ groupOption.value.name }}
                    </div>
                  </div>
                </div>
              </mat-expansion-panel>
            </div>
          }
        </mat-accordion>
      }
    </ng-template>

    <ng-template #labelTemplate let-labelText=labelText>
      <label class="control-label" #me #tt="matTooltip" matTooltipDisabled
        matTooltip="{{ labelText }}" matTooltipPosition="above"
      overflowTooltip [textElement]="me" [elementTooltip]="tt">{{ labelText }}</label>
    </ng-template>
